import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { material } from "../MaterialsSlice";

// Models
export interface price {
    glass_id?: string,
    glass_work_id?: string,
    price: string,
}

export interface select {
    value: string | number,
    label: string
}

export interface glassWork {
    id: number,
    name: string,
    code: string
}

// Add material state
export interface materialPricingState {
    material?: material,
    services: glassWork[],
    prices: price[],
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialMaterialPricingState: materialPricingState = {
    prices: [],
    services: [],
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const materialPricingSlice = createSlice({
    name: 'material_pricing',
    initialState: initialMaterialPricingState,
    reducers: {
        init: state => initialMaterialPricingState,
        set: (state, { payload }: PayloadAction<[price]>) => {
            state.prices = [...state.prices, ...payload]
        },
        setPriceValue: (state, { payload }: PayloadAction<{ index: number, value: string }>) => {
            state.prices[payload.index].price = payload.value;
        },
        setService: (state, { payload }: PayloadAction<{ index: number, value: string }>) => {
            state.prices[payload.index].glass_work_id = payload.value;
        },
        setMaterial: (state, { payload }: PayloadAction<material>) => {
            state.material = payload;
        },
        deletePrice: (state, { payload }: PayloadAction<number>) => {
            state.prices.splice(payload, 1)
        },
        setEditId: (state, { payload }: PayloadAction<number>) => {
            state.editId = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
        addServices: (state, { payload }: PayloadAction<glassWork[]>) => {
            state.services = payload
        },
    }
})